import { Controller } from '@hotwired/stimulus';

import { getStorage, setStorage } from '@/modules/storage';

const THEME_COLOR_DARK = '#080d16';
const THEME_COLOR_LIGHT = '#ffffff';

export default class extends Controller {
  static targets = ['toggle'];

  connect() {
    const dark = this.#isDark();

    this.#apply(dark);

    if (this.hasToggleTarget) {
      this.toggleTarget.checked = dark;
    }
  }

  #apply(dark) {
    const html = document.documentElement;

    this.#applyThemeColor(dark);

    if (dark) {
      html.dataset.theme = 'dark';

      try {
        setStorage('theme', 'dark');
      } catch (error) {
        /* storage blocked */
      }

      return;
    }

    delete html.dataset.theme;

    try {
      setStorage('theme', 'light');
    } catch (error) {
      /* storage blocked */
    }
  }

  // The theme-color meta only understands media queries, so it cannot follow the manual data-theme toggle on its own
  #applyThemeColor(dark) {
    const content = dark ? THEME_COLOR_DARK : THEME_COLOR_LIGHT;

    document.head.querySelectorAll('meta[name="theme-color"]').forEach((item) => {
      item.removeAttribute('media');

      item.content = content;
    });
  }

  #isDark() {
    try {
      return getStorage('theme') === 'dark';
    } catch (error) {
      return false;
    }
  }

  toggle() {
    this.#apply(this.toggleTarget.checked);
  }
}
